import {Stack, Typography} from "@mui/material";
import InfoOutlineIcon from "@mui/icons-material/InfoOutline";

const CampsEnglish = () => {
    return (
        <Stack direction="column" padding="20px">
            <Typography variant="h4" component="h1" fontWeight="medium" marginBottom="10px">
                Tabere de limba engleză
            </Typography>

            <Stack direction="row" spacing={2} alignItems="flex-start">
                <InfoOutlineIcon color="primary"/>
                <Typography variant="caption" fontWeight="medium" marginBottom="10px">
                    Momentan nu avem tabere de limba engleză programate, dar vă rugăm să ne contactați dacă sunteți
                    interesați.
                </Typography>
            </Stack>
        </Stack>
    )
}

export default CampsEnglish;